import type { AssistantSurfaceSnapshotReference, definitions } from '@luxuryescapes/contract-trip'

export type AssistantSurfaceSnapshotRef = definitions['assistantSurfaceSnapshotRef']
export type DegradedSurfaceIdentity = definitions['degradedSurfaceIdentity']
export type SurfaceManifestFactRequest = definitions['surfaceManifestFactRequest']
export type SurfaceVisibleStateRequest = definitions['surfaceVisibleStateRequest']
export type SurfaceRecentCommittedStateRequest = definitions['surfaceRecentCommittedStateRequest']
export type SurfaceAtomRequest = definitions['surfaceAtomRequest']
export type SurfaceTargetRequest = definitions['surfaceTargetRequest']
export type SurfaceCapabilityRequest = definitions['surfaceCapabilityRequest']
export type AssistantSurfaceSnapshotRequest = definitions['assistantSurfaceSnapshotRequest']
export type AssistantSurfaceSnapshotChunkKind = definitions['assistantSurfaceSnapshotChunkRef']['kind']
export type AssistantSurfaceSnapshotChunkRef = definitions['assistantSurfaceSnapshotChunkRef']
export type AssistantSurfaceSnapshotChunkManifest = definitions['assistantSurfaceSnapshotChunkManifest']
export type AssistantSurfaceSnapshotChunk = definitions['assistantSurfaceSnapshotChunk']

export function toChatMessageSnapshotReference(
  snapshotRef: AssistantSurfaceSnapshotRef,
): AssistantSurfaceSnapshotReference {
  return {
    snapshotRefId: snapshotRef.snapshotRefId,
    surface: snapshotRef.surface,
    surfaceContextScopeKey: snapshotRef.surfaceContextScopeKey,
    snapshotFingerprint: snapshotRef.snapshotFingerprint,
  }
}
